export const COHORT_NAME = '@cohortname/COHORT_NAME';
export const COHORT_TYPE = '@cohorttype/COHORT_TYPE';
export const COHORT_AREANAME = '@cohortareaname/COHORT_AREANAME'
export const SELECT_USER = '@selectuser/SELECT_USER'
export const SELECT_VM = '@selectvm/SELECET_VM'
